import { Directory, Filesystem } from "@capacitor/filesystem";
import { TileServerPlugin } from "@newaydata/capacitor-tile-server";

let baseUrlPromise: Promise<string> | null = null;

/**
 * Boot the loopback tile-server (idempotent) and return its baseUrl. Tile URLs
 * (e.g. `base/512/{z}/{x}/{y}.jpg`) are joined onto this baseUrl by the layer
 * setup code, replacing the old `efbtile://` maplibre-gl protocol handler.
 *
 * The server's rootDir is the absolute path of `Directory.Data`, so a tile
 * URL of `<dir>/<z>/<x>/<y>.png` maps to a file at `<Directory.Data>/<dir>/<z>/<x>/<y>.png`.
 */
export function startTileServer(): Promise<string> {
  if (baseUrlPromise) return baseUrlPromise;
  baseUrlPromise = (async () => {
    const probe = await Filesystem.getUri({ directory: Directory.Data, path: "" });
    const rootDir = probe.uri.replace(/^file:\/\//, "").replace(/\/$/, "");
    await TileServerPlugin.configure({ rootDir });
    const { baseUrl } = await TileServerPlugin.start();
    return baseUrl.replace(/\/$/, "");
  })();
  return baseUrlPromise;
}
